import React from 'react';
import { connect } from 'react-redux';
import { Handler } from 'ml-component-web';
import InvitationHandlerView from './InvitationHandlerView';
import { hasLoadedInvitation, loadInvitation } from '../action/invitationActions';
import { getInvitation } from '../store/invitationStore';

class InvitationHandler extends Handler {
    constructor(props, context) {
        super(props, context, InvitationHandlerView);
    }

    loadData(props) {
        const { dispatch, invitationId } = props;
        loadInvitation(dispatch, invitationId);
    }

    renderHandler() {
        const { invitation } = this.props;

        return (
            <InvitationHandlerView
                invitation={invitation}
            />
        );
    }
}

function mapStateToProps(state, props) {
    const invitationId = props.location && props.location.query && props.location.query.i;
    const status = hasLoadedInvitation(state, invitationId);
    return {
        ...status,
        invitationId,
        invitation: getInvitation(state, { invitationId }),
    };
}

export default connect(mapStateToProps)(InvitationHandler);



/** WEBPACK FOOTER **
 ** ./src/handler/InvitationHandler.js
 **/